<template>
  <div class="registration">
    <add :readonly="readonly" @next="next" @userChangedCompetitionType="onUserChangedCompetitionType" />
    <step1 :form="data.step1" :cates="normalizedCates" :describe="describe" :readonly="readonly" />
    <step2
      :id="id"
      :form="data.step2"
      :cates="dictionary.cates"
      :market-launch="dictionary.market_launch"
      :describe="describe"
      :readonly="readonly"
      :saved-thumbs-num="savedImagesNum"
      :saved-market-file-num="savedMarketFileNum"
      :product-confirm="productConfirm"
      @save="save"
      @setSavedImagesNum="setSavedImagesNum"
      @setSavedMarketFileNum="setSavedMarketFileNum"
      @setSavedVideosNum="setSavedVideosNum"
    />
    <step4 style="margin-top: 50px; margin-bottom: 80px;" :form="data.step4" :describe="describe" :readonly="readonly" @setStep4="setStep4" />
    <!-- 点击，返回首页，返回上一步，下一步和保存 -->
    <footer>
      <!-- 返回 -->
      <a-button
        v-if="readonly || isEdit"
        @click="goBack"
      >
        {{ $t('view-components-components/return') }}
      </a-button>
      <!-- 保存，即未完成报名的才会有 -->
      <a-button
        v-if="!readonly"
        :type="productConfirm ? 'primary' : ''"
        @click="save"
      >
        {{ productConfirm ? $t('register-verify/submit') : $t('user-tools/save') }}
      </a-button>
      <!-- 完成报名按钮 -->
      <!-- v-if="(!isEdit || register_status == 0 || register_status == 1) && !readonly" -->
      <a-button
        type="primary"
        @click="complete"
      >
        {{ $t('user-tools/complete') }}
      </a-button>
    </footer>
  </div>
</template>
<script>
import add from './components/add'
import step1 from './components/step1'
import step2 from './components/step2'
import step4 from './components/step4'

import { products, eidtProducts, putProducts } from '@/api/product'
import { setPageKey, getPageKey, removePageKey } from '@/utils/auth'

// const CounterByte = function(str) {
//   if (!str) return 0
//   var count = 0
//   for (var i = 0, l = str.length; i < l; i++) {
//     count += str.charCodeAt(i) <= 128 ? 1 : 2
//   }
//   return count
// }

export default {
  components: {
    add,
    step1,
    step2,
    step4
  },
  props: {
    editId: {
      type: Number,
      default: 0
    },
    productConfirm: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      step: 0,
      data: {
        step1: {
          category_id: '',
          name_cn: '',
          type_cn: '',
          commission_id: '',
          product_label: [],
          user_label: [],
          manager_id: '',
          channel_type: '',
          channel_remark: '',
          other: ''
          // supervisor: '',
          // patentApplied: '',
          // copyrightRegistered: ''
        },
        step2: {
          market_launch: '',
          thumbs: [],
          market_file: [],
          videos: [],
          description_cn: '',
          width: '',
          height: '',
          depth: '',
          feedback: ''
        },
        step3: {
          id: '',
          company_name: '',
          company_ename: '',
          street: '',
          zip: '',
          city: '',
          country: '',
          homepage: '',
          address_phone: '',
          address_email: '',
          address_fax: '',
          contact: [{
            form: '',
            title: '',
            firstname: '',
            lastname: '',
            name: '',
            email: '',
            position: '',
            phone: ''
          }]
        },
        step4: {
          design_addrss: [],
          design_address: []
        },
        step5: {
          submission: '',
          width: '',
          height: '',
          depth: '',
          submitted_items: ''
        }
      },
      isEdit: false, // 表示从其他页面过来编辑的
      register_status: 0, // 从其他页面过来的，0未注册，1已注册, 非管理员1不能修改(1可修改2020/11/6)
      id: 0,
      readonly: false,
      describe: {},
      savedImagesNum: 0, // 已保存图片数量
      savedMarketFileNum: 0, // 已保存的市场化证明材料数量
      savedVideosNum: 0, // 已保存视频数量
      isAdmin: false,
      isInitializing: false, // 标记是否正在初始化编辑数据
      userChangedCompetitionType: false // 标记用户是否主动修改了竞赛类型
    }
  },
  computed: {
    dictionary() {
      return this.$store.state.global.dictionary || {
        cates: []
      }
    },
    isProductInnovation() {
      if (!this.dictionary.cates) {
        return false
      }
      return this.dictionary.cates.slice(1).find(a => a.value === this.$store.state.global.competitionCategory)?.name.includes('产品创新')
    },
    normalizedCates() {
      const cates = this.dictionary.cates || []
      // const currentId = this.data.step1 && this.data.step1.category_id
      // if (this.isEdit && currentId && !cates.some(i => String(i.value) === String(currentId))) {
      //   // 在编辑模式下，如果字典里不存在接口返回的类别，插入一个占位选项以保证选择框能显示
      //   return [{ value: currentId, name: '当前类别' }].concat(cates)
      // }
      return cates
    }
  },
  watch: {
    step(e) {
      setPageKey('productStep', e)
    },
    // 监听赛事类型变化，清空类别选择
    '$store.state.global.currentCompetitionType'(newVal, oldVal) {
      console.log('[DEBUG] ===== COMPETITION TYPE WATCHER TRIGGERED =====')
      console.log('[DEBUG] newVal:', newVal, 'oldVal:', oldVal)
      console.log('[DEBUG] this.data.step1.category_id before watcher:', this.data.step1.category_id)
      console.log('[DEBUG] this.isEdit:', this.isEdit)
      console.log('[DEBUG] this.isInitializing:', this.isInitializing)
      console.log('[DEBUG] this.userChangedCompetitionType:', this.userChangedCompetitionType)

      if (newVal !== oldVal && oldVal) {
        // 只有在非初始化状态下，用户主动修改赛事类型时才清空类别选择
        if (this.isInitializing) {
          console.log('[DEBUG] Competition type change during initialization, keeping category_id')
        } else if (this.userChangedCompetitionType) {
          // 用户主动修改竞赛类型，清空类别选择
          console.log('[DEBUG] User changed competition type, clearing category_id')
          this.data.step1.category_id = ''
          this.$store.commit('global/SET_COMPETITION_CATEGORY', '')
          console.log('[DEBUG] Competition type changed by user, cleared category_id')
          // 重置标志
          this.userChangedCompetitionType = false
        } else if (this.isEdit && this.data.step1.category_id) {
          // 编辑模式下，如果已经有category_id，说明是从API加载的数据，不清空
          console.log('[DEBUG] Edit mode with existing category_id, keeping category_id:', this.data.step1.category_id)
        } else {
          // 其他情况（如新建模式下的用户操作），清空类别
          console.log('[DEBUG] Other case (new mode or no existing category), clearing category_id')
          this.data.step1.category_id = ''
          this.$store.commit('global/SET_COMPETITION_CATEGORY', '')
        }
      } else {
        console.log('[DEBUG] Competition type watcher condition not met')
      }

      console.log('[DEBUG] this.data.step1.category_id after watcher:', this.data.step1.category_id)
    },
    // 当字典里的类别(cates)加载完成后，确保类别ID能正确匹配和显示
    'dictionary.cates'(newCates) {
      try {
        console.log('[DEBUG] ===== DICTIONARY.CATES WATCHER TRIGGERED =====')
        console.log('[DEBUG] dictionary.cates updated:', newCates && newCates.length, newCates)
        console.log('[DEBUG] this.data.step1.category_id before dictionary watcher:', this.data.step1.category_id)

        if (!newCates || !newCates.length) {
          console.log('[DEBUG] No cates available, returning')
          return
        }

        const current = this.data.step1.category_id
        console.log('[DEBUG] current form.category_id before match:', current)
        if (current === '' || current === null || typeof current === 'undefined') {
          console.log('[DEBUG] category_id is empty, skipping match')
          return
        }

        // 检查当前类别ID是否在新的类别列表中
        const matched = newCates.find(i => String(i.value) === String(current))
        console.log('[DEBUG] matched cate by value:', matched)

        if (matched) {
          // 如果找到匹配的类别，确保表单中的值正确设置
          console.log('[DEBUG] Found matching category, setting category_id to:', matched.value)
          this.data.step1.category_id = matched.value
          this.$store.commit('global/SET_COMPETITION_CATEGORY', matched.value)
          console.log('[DEBUG] category_id matched and set to:', matched.value)
        } else {
          // 如果没有找到匹配的类别，可能是类别列表不包含该ID
          console.warn('[DEBUG] No matched cate for category_id:', current)
          console.log('[DEBUG] Available cates:', newCates.map(c => ({ value: c.value, name: c.name })))

          // 在编辑模式下，如果找不到匹配的类别，保持原值但添加调试信息
          if (this.isEdit) {
            console.log('[DEBUG] Edit mode: keeping original category_id even if not in current cates:', current)
          }
        }

        console.log('[DEBUG] this.data.step1.category_id after dictionary watcher:', this.data.step1.category_id)
      } catch (e) {
        console.error('[DEBUG] Error in dictionary.cates watcher:', e)
      }
    }
  },
  created() {
    // user.role
    this.isAdmin = this.$store.getters.user.role !== 1
    // storeBefore().then(res => {
    //   console.log('2')
    //   res.managers = [{
    //     id: 0,
    //     lastname: '无',
    //     firstname: '',
    //     name: ''
    //   }].concat(res.managers)
    //   this.dictionary = res
    // }).catch(res => {
    //   console.error(res)
    // })

    const id = getPageKey('editProductId')
    const step = getPageKey('productStep')
    const readonly = getPageKey('readonly')
    if (step) this.step = step
    this.readonly = Boolean(readonly)
    console.log('id', id, this.editId)
    if (id || this.editId) {
      this.id = id || this.editId
      if (this.productConfirm) {
        this.step = [2, 3, 4, '2', '3', '4'].indexOf(step) !== -1 ? step : 2
      } else {
        this.step = step || 1
      }
      this.isEdit = true
      this.getProducts()
    } else {
      setPageKey(0)
      this.step = 0
    }
  },
  methods: {
    onUserChangedCompetitionType() {
      // 用户主动修改了竞赛类型，设置标志
      this.userChangedCompetitionType = true
      console.log('[DEBUG] User changed competition type, flag set to true')
      console.log('[DEBUG] Current userChangedCompetitionType flag:', this.userChangedCompetitionType)
    },
    pre() {
      switch (this.step) {
        case 2: {
          this.step = 1
          break
        }
        case 4: {
          this.step = 2
          break
        }
      }
    },
    next() {
      if (this.step === 1 && !this.id) this.save()
      switch (this.step) {
        case 0: {
          this.step = 1
          break
        }
        case 1: {
          this.step = 2
          break
        }
        case 2: {
          this.step = 4
          break
        }
      }
    },
    goStep(step) {
      if (!this.id) this.save()
      this.step = step
    },
    setData(key, data) {
      this.data[key] = data
    },
    setStep3(address) {
      console.log(address)
      if (address && address.contact) {
        for (const i in address.contact) {
          address.contact[i].form = String(address.contact[i].form || '')
        }
      }
      this.data.step3 = this.changeAddress(address)
    },
    setStep4(address, type, isDel) {
      console.log(address, type)
      if (isDel) {
        const index = address
        this.data.step4[type].splice(index, 1)
        // 如果是删除 design_address，同时删除对应的 design_addrss
        if (type === 'design_address' && this.data.step4.design_addrss) {
          this.data.step4.design_addrss.splice(index, 1)
        }
      } else {
        if (type === 'design_address') {
          // 处理 design_address 类型，创建完整的 design_addrss 对象
          const processedAddress = this.changeAddress(address)
          const id = processedAddress.id

          // 检查是否已存在
          const existingIndex = this.data.step4.design_address.findIndex(item => item.id === id)
          if (existingIndex !== -1) {
            return this.$message.warning({ content: this.$t('view-components-components/existed'), key: 'message', duration: 4 })
          }

          // 添加到 design_address 数组
          this.data.step4.design_address.push(processedAddress)

          // 创建并添加到 design_addrss 数组
          const designAddrssItem = {
            id: null, // 新添加的项，ID为null
            product_id: this.id || null,
            address_id: processedAddress.id.toString(),
            type: '1', // 默认类型
            address: processedAddress
          }
          if (!this.data.step4.design_addrss) {
            this.data.step4.design_addrss = []
          }
          this.data.step4.design_addrss.push(designAddrssItem)
        } else {
          // 处理其他类型
          address = this.changeAddress(address)
          const id = address.id
          const array = this.data.step4[type]
          for (const i in array) {
            if (array[i].id === id) return this.$message.warning({ content: this.$t('view-components-components/existed'), key: 'message', duration: 4 })
          }
          this.data.step4[type].push(address)
        }
      }
    },
    checkSaveImage() {
      const thumbs = this.data.step2.thumbs
      for (const i in thumbs) {
        // 没url表示本地修改过，没isSaved表示为上传至服务器
        if (!thumbs[i].url && !thumbs[i].isSaved) return false // 返回失败
      }
      return true
    },
    checkSaveVideo() {
      const videos = this.data.step2.videos
      for (const i in videos) {
        // 没url表示本地修改过，没isSaved表示为上传至服务器
        if (!videos[i].url && !videos[i].isSaved) return false // 返回失败
      }
      return true
    },
    async save() {
      // 验证类别是否为空
      if (!this.data.step1.category_id || this.data.step1.category_id === '' || this.data.step1.category_id === null || this.data.step1.category_id === undefined) {
        return this.$message.warning({ content: this.$t('view-components-components/tip26'), key: 'message', duration: 4 })
      }
      // if (this.step === 1 && (!this.data.step1.category_id || !this.data.step1.name_cn || !this.data.step1.name_en || !this.data.step1.type_cn || !this.data.step1.type_en || !this.data.step1.commission_id)) {
      //   return this.$message.warning({ content: this.$t('user-comphonents-process/perfect'), key: 'message', duration: 4 })
      // }
      // if (this.step === 2 && (this.data.step2.description_cn.trim().length > 500 || this.data.step2.description_cn.trim().length < 300)) {
      //   return this.$message.error({ content: this.$t('view-components-components/zdescription'), key: 'message', duration: 4 })
      // }
      // if (!this.checkSaveImage()) {
      //   return this.$message.warning({ content: this.$t('admin-products-products/pUpload'), key: 'message', duration: 4 })
      // }
      // 数据处理
      const data = {
        ...this.data.step1,
        ...this.data.step2,
        design_addrss: this.data.step4.design_addrss || [],
        design_address: this.data.step4.design_address.map(i => i.id)
      }

      // 处理视频数据，提取视频URL
      if (this.data.step2.videos && this.data.step2.videos.length > 0) {
        data.videos = this.data.step2.videos.map(video => video.url).filter(url => url)
      } else {
        data.videos = []
      }

      // 图片处理，这里无需再上传图片
      delete data.old_images
      delete data.thumbs
      delete data.market_file

      const that = this
      async function goSave(_data) {
        await eidtProducts(that.id, _data, that.$store.state.global.currentCompetitionType).then(res => {
          that.$message.success({ content: that.$t('admin-password-password/savey'), key: 'message', duration: 4 })
          if (res.id) {
            that.id = res.id
            setPageKey('editProductId', res.id)
          }

          if (res.pi_code) that.$set(that.describe, 'pi_code', res.pi_code)
          if (that.data.step1.name_cn) that.$set(that.describe, 'name_cn', that.data.step1.name_cn)
          if (that.productConfirm) {
            removePageKey('editProductId')
            removePageKey('readonly')
            setTimeout(() => {
              if (window && window.location) {
                window.location.reload()
              } else {
                that.$router.go(0)
              }
            }, 2000)
          }
        }).catch(res => {
          console.error(res)
        })
      }

      if (this.productConfirm) {
        data.confirmation_status = 1
        this.$confirm({
          content: this.$t('view-components-components/tip19'),
          okText: this.$t('view-components-components/confirm'),
          cancelText: this.$t('admin-profile-edit/cancel'),
          onOk() {
            goSave(data)
          },
          onCancel() {
          }
        })
      } else {
        await goSave(data)
      }
    },
    async complete() {
      if (!this.id) await this.save()

      const that = this
      const data = {
        ...this.data.step1,
        ...this.data.step2,
        design_addrss: this.data.step4.design_addrss || [],
        design_address: this.data.step4.design_address.map(i => i.id)
      }

      // 处理视频数据，提取视频URL
      if (this.data.step2.videos && this.data.step2.videos.length > 0) {
        data.videos = this.data.step2.videos.map(video => video.url).filter(url => url)
      } else {
        data.videos = []
      }

      // 各种验证
      const checker = {
        category_id: {
          bool: !data.category_id || data.category_id === '' || data.category_id === null || data.category_id === undefined,
          step: 1,
          content: this.$t('view-components-components/tip26')
        },
        name_cn: {
          bool: !data.name_cn,
          step: 1,
          content: this.$t('view-components-components/tip27')
        },
        // name_en: {
        //   bool: !data.name_en,
        //   step: 1,
        //   content: this.$t('view-components-components/tip28')
        // },
        // type_cn: {
        //   bool: !data.type_cn,
        //   step: 1,
        //   content: this.$t('view-components-components/tip29')
        // },
        // type_en: {
        //   bool: !data.type_en,
        //   step: 1,
        //   content: this.$t('view-components-components/tip30')
        // },

        channel_type: {
          bool: !data.channel_type,
          step: 1,
          content: this.$t('user-comphonents-step1/select_patent_status')
        },
        commission_id: {
          bool: !data.commission_id,
          step: 1,
          content: this.$t('view-components-components/tip37')
        },
        description_cn: {
          bool: !data.description_cn,
          step: 2,
          content: this.$t('view-components-components/tip32')
        }
        // description_en: {
        //   bool: !data.description_en,
        //   step: 2,
        //   content: this.$t('view-components-components/tip33')
        // },
        // height: {
        //   bool: !data.height && (typeof data.height !== 'number'),
        //   step: 2,
        //   content: this.$t('view-components-components/tip34')
        // },
        // width: {
        //   bool: !data.width && (typeof data.width !== 'number'),
        //   step: 2,
        //   content: this.$t('view-components-components/tip35')
        // },
        // depth: {
        //   bool: !data.depth && (typeof data.depth !== 'number'),
        //   step: 2,
        //   content: this.$t('view-components-components/tip36')
        // }
      }
      for (const i in checker) {
        if (checker[i].bool) {
          this.step = checker[i].step
          return this.$message.error({ content: checker[i].content, key: 'message', duration: 4 })
        }
      }
      console.log('this.data.step2', this.data.step2)
      if (this.isProductInnovation && (this.data.step2.market_file.length < 1 || this.data.step2.market_file.length > 5)) {
        console.log('qqqqqq')
        this.step = 2
        return this.$message.error({ content: this.$t('view-components-components/tip38'), key: 'message', duration: 4 })
      }

      // if (!data.category_id || !data.name_cn || !data.name_en || !data.type_cn || !data.type_en || !data.commission_id || !data.channel_type || (data.channel_type === 7 && !data.channel_remark) || (data.channel_type === 8 && !data.channel_remark)) {
      //   this.step = 1
      //   return this.$message.error({ content: this.$t('user-comphonents-process/perfect'), key: 'message', duration: 4 })
      // }
      if (this.savedImagesNum < 1) {
        this.step = 2
        return this.$message.error({ content: this.$t('view-components-components/least'), key: 'message', duration: 4 })
      }
      // if (!data.description_cn || !data.description_en || !data.width || !data.height || !data.depth) {
      //   this.step = 2
      //   return this.$message.error({ content: this.$t('view-components-components/description'), key: 'message', duration: 4 })
      // }
      if (data.description_cn.trim().length > 300 || data.description_cn.trim().length < 10) {
        this.step = 2
        return this.$message.error({ content: this.$t('view-components-components/zdescription'), key: 'message', duration: 4 })
      }
      if (!data.design_address.length) {
        this.step = 4
        return this.$message.error({ content: this.$t('view-components-components/design'), key: 'message', duration: 4 })
      }
      // 处理视频数据，提取视频URL
      if (this.data.step2.videos && this.data.step2.videos.length > 0) {
        data.videos = this.data.step2.videos.map(video => video.url).filter(url => url)
      } else {
        data.videos = []
      }

      // 图片处理，这里无需再上传图片
      delete data.old_images
      delete data.thumbs
      delete data.market_file

      putProducts(that.id, data, that.$store.state.global.currentCompetitionType).then(() => {
        removePageKey('editProductId')
        removePageKey('readonly')
        that.$message.success({ content: that.$t('admin-password-password/savey'), key: 'message', duration: 4 })

        // 编辑模式下不显示"是否继续报名"弹窗，直接跳转
        if (that.isEdit) {
          if (that.editId) {
            if (window && window.location) {
              window.location.reload()
            } else {
              that.$router.go(0)
            }
          } else {
            const isAdmin = that.$store.getters.user.role !== 1
            that.$router.push({
              path: !isAdmin ? '/user/myProduct' : '/admin/products'
            })
          }
        } else {
          // 只有新建报名时才显示"是否继续报名"弹窗
          this.againRegistration()
        }
      }).catch(res => {
        console.error(res)
      })
    },
    againRegistration() {
      const that = this
      this.$confirm({
        content: this.$t('user-tools/isComplete'),
        okText: this.$t('view-components-components/next'),
        cancelText: this.$t('admin-profile-edit/cancel'),
        onOk() {
          that.data = {
            step1: {
              category_id: that.data.step1.category_id,
              name_cn: '',
              type_cn: '',
              commission_id: that.data.step1.commission_id,
              product_label: [],
              user_label: [],
              manager_id: '',
              channel_type: that.data.step1.channel_type,
              channel_remark: '',
              other: ''
              // supervisor: '',
              // patentApplied: '',
              // copyrightRegistered: ''
            },
            step2: {
              market_launch: '',
              thumbs: [],
              market_file: [],
              description_cn: '',
              width: '',
              height: '',
              depth: '',
              feedback: ''
            },
            step3: {
              id: '',
              company_name: '',
              company_ename: '',
              street: '',
              zip: '',
              city: '',
              country: '',
              homepage: '',
              address_phone: '',
              address_email: '',
              address_fax: '',
              contact: [{
                form: '',
                title: '',
                firstname: '',
                lastname: '',
                name: '',
                email: '',
                position: '',
                phone: ''
              }]
            },
            step4: {
              design_addrss: [],
              design_address: []
            },
            step5: {
              submission: '',
              width: '',
              height: '',
              depth: '',
              submitted_items: ''
            }
          }
          that.step = 0
          that.isEdit = false // 表示从其他页面过来编辑的
          that.register_status = 0 // 从其他页面过来的，0未注册，1已注册, 非管理员1不能修改(1可修改2020/11/6)
          that.id = 0
          that.readonly = false
          that.describe = {}
          that.savedImagesNum = 0 // 已保存图片数量
          that.savedMarketFileNum = 0 // 已保存的市场化证明材料数量
          that.savedVideosNum = 0 // 已保存视频数量
          that.isAdmin = false
        },
        onCancel() {
          if (that.editId) {
            if (window && window.location) {
              window.location.reload()
            } else {
              that.$router.go(0)
            }
          } else {
            const isAdmin = that.$store.getters.user.role !== 1
            that.$router.push({
              path: !isAdmin ? '/user/myProduct' : '/admin/products'
            })
          }
        }
      })
    },
    changeAddress(address) {
      address.address_phone = address.phone
      address.address_email = address.email
      address.address_fax = address.fax
      delete address.phone
      delete address.email
      delete address.fax
      return address
    },
    getProducts() {
      const id = this.id
      console.log('[DEBUG] ===== getProducts START =====')
      console.log('[DEBUG] Current state before API call:')
      console.log('[DEBUG] - this.data.step1.category_id:', this.data.step1.category_id)
      console.log('[DEBUG] - store.currentCompetitionType:', this.$store.state.global.currentCompetitionType)
      console.log('[DEBUG] - store.competitionCategory:', this.$store.state.global.competitionCategory)

      // 设置初始化标志，防止监听器清空类别
      this.isInitializing = true
      console.log('[DEBUG] Set isInitializing to true')

      // 如果接口返回了type字段，优先使用接口返回的type
      products(id).then(res => {
        const data = res.product
        console.log('[DEBUG] ===== API RESPONSE =====')
        console.log('[DEBUG] getProducts response.product:', data)
        console.log('[DEBUG] product.category_id from API:', data && data.category_id)
        console.log('[DEBUG] product.type from API:', data && data.type)

        // 优先使用接口返回的type字段，如果没有则根据pi_code判断
        let competitionType = '1' // 默认综合赛
        if (data.type) {
          competitionType = data.type.toString()
        } else if (data.pi_code && data.pi_code.includes('QYS')) {
          competitionType = '2' // 企业命题赛
        }

        // 先设置 category_id，确保在字典监听器触发时已经有值
        console.log('[DEBUG] ===== SETTING STEP1 DATA (FIRST TIME) =====')
        console.log('[DEBUG] Setting this.data.step1.category_id to:', data.category_id || '')
        this.data.step1 = {
          category_id: data.category_id || '',
          name_cn: data.name_cn,
          type_cn: data.type_cn,
          commission_id: data.commission_id,
          name_en: data.name_en,
          type_en: data.type_en,
          commission_en: data.commission_en,
          brand_cn: data.brand_cn,
          brand_en: data.brand_en,
          model_cn: data.model_cn,
          model_en: data.model_en,
          material_cn: data.material_cn,
          material_en: data.material_en,
          size_cn: data.size_cn,
          size_en: data.size_en,
          weight_cn: data.weight_cn,
          weight_en: data.weight_en,
          color_cn: data.color_cn,
          color_en: data.color_en,
          function_cn: data.function_cn,
          function_en: data.function_en,
          feature_cn: data.feature_cn,
          feature_en: data.feature_en,
          advantage_cn: data.advantage_cn,
          advantage_en: data.advantage_en,
          market_cn: data.market_cn,
          market_en: data.market_en,
          patent_cn: data.patent_cn,
          patent_en: data.patent_en,
          copyright_cn: data.copyright_cn,
          copyright_en: data.copyright_en,
          trademark_cn: data.trademark_cn,
          trademark_en: data.trademark_en,
          other_cn: data.other_cn,
          other_en: data.other_en
        }

        // 立即打印调试信息
        console.log('[DEBUG] ===== AFTER FIRST STEP1 SET =====')
        console.log('[DEBUG] step1.category_id set to:', this.data.step1.category_id)
        console.log('[DEBUG] this.data.step1:', this.data.step1)
        this.data.step2 = {
          images: data.images || [],
          videos: data.videos || [],
          files: data.files || []
        }
        this.data.step3 = {
          company_name: data.company_name,
          company_en: data.company_en,
          company_address: data.company_address,
          company_address_en: data.company_address_en,
          company_phone: data.company_phone,
          company_email: data.company_email,
          company_website: data.company_website,
          contact_name: data.contact_name,
          contact_en: data.contact_en,
          contact_phone: data.contact_phone,
          contact_email: data.contact_email,
          contact_address: data.contact_address,
          contact_address_en: data.contact_address_en
        }
        this.data.step4 = {
          design_addrss: data.design_addrss || [],
          design_address: data.design_address || [],
          design_address_en: data.design_address_en,
          design_phone: data.design_phone,
          design_email: data.design_email,
          design_website: data.design_website,
          design_name: data.design_name,
          design_en: data.design_en,
          design_address_detail: data.design_address_detail,
          design_address_detail_en: data.design_address_detail_en
        }
        this.data.step5 = {
          invoice_type: data.invoice_type,
          invoice_title: data.invoice_title,
          invoice_tax_number: data.invoice_tax_number,
          invoice_address: data.invoice_address,
          invoice_phone: data.invoice_phone,
          invoice_bank: data.invoice_bank,
          invoice_account: data.invoice_account
        }
        this.$store.dispatch('global/getDistricts')
        // 观察字典是否按期到达
        setTimeout(() => {
          const dict = (this.$store.state.global.dictionary || {})
          console.log('[DEBUG] dictionary after getDistricts (500ms):', {
            hasDict: !!dict,
            catesLen: dict.cates && dict.cates.length,
            sampleCates: dict.cates && dict.cates.slice && dict.cates.slice(0, 5)
          })
        }, 500)

        // 更新 step1 的其他字段
        console.log('[DEBUG] ===== SETTING STEP1 DATA (SECOND TIME) =====')
        console.log('[DEBUG] Before second step1 set:')
        console.log('[DEBUG] - this.data.step1.category_id:', this.data.step1.category_id)
        console.log('[DEBUG] - data.category_id:', data.category_id)

        this.data.step1 = {
          ...this.data.step1,
          category_id: data.category_id || '', // 确保category_id不被丢失
          product_label: data.product_label,
          user_label: data.user_label,
          manager_id: data.manager_id,
          channel_type: '' + data.channel_type,
          channel_remark: data.channel_remark,
          other: data.other
        }

        console.log('[DEBUG] After second step1 set:')
        console.log('[DEBUG] - this.data.step1.category_id:', this.data.step1.category_id)
        console.log('[DEBUG] - this.data.step1:', this.data.step1)
        this.data.step2 = {
          market_launch: data.market_launch || '',
          thumbs: data.thumbs.map((item, index) => {
            return {
              uid: index,
              url: item,
              name: 'image.png',
              status: 'done'
            }
          }),
          market_file: data.market_file.map((item, index) => {
            return {
              uid: index,
              url: item,
              name: 'image.png',
              status: 'done'
            }
          }),
          videos: data.videos ? data.videos.map((item, index) => {
            return {
              uid: index,
              url: item,
              name: 'video.mp4',
              status: 'done'
            }
          }) : [],
          description_cn: data.description_cn,
          width: data.width,
          height: data.height,
          depth: data.depth,
          feedback: data.feedback
        }
        // 记录已保存图片数量
        this.savedImagesNum = data.thumbs.length
        this.savedMarketFileNum = data.market_file.length
        this.savedVideosNum = data.videos ? data.videos.length : 0
        // 保存完整的 design_addrss 对象
        if (data.design_addrss && data.design_addrss.length > 0) {
          this.data.step4.design_addrss = data.design_addrss
          // 同时保持 design_address 的兼容性，用于显示
          this.data.step4.design_address = data.design_addrss.map(item => this.changeAddress(item.address))
        }
        // this.$set(this.data.step4.design_address, this.data.step4.design_address.length, data.design_addrss.map(a => this.changeAddress(a.address)))
        this.data.step5 = {
          submission: data.submission || '',
          width: data.width,
          height: data.height,
          depth: data.depth,
          submitted_items: data.submitted_items
        }
        this.register_status = data.register_status
        this.describe = {
          name_cn: data.name_cn,
          pi_code: data.pi_code,
          register_status: data.register_status
        }
        console.log('this.data.step4.design_address', this.data.step4.design_address)

        // 在所有数据设置完成后，使用nextTick确保在下一个事件循环中设置竞赛类型
        console.log('[DEBUG] ===== SETTING COMPETITION TYPE AFTER ALL DATA SET =====')
        this.$nextTick(() => {
          console.log('[DEBUG] set currentCompetitionType ->', competitionType)
          this.$store.commit('global/SET_CURRENT_COMPETITION_TYPE', competitionType)
          this.$store.commit('global/SET_COMPETITION_CATEGORY', data.category_id)
          console.log('[DEBUG] dispatch getDistricts (load dictionary by type)')
          this.$store.dispatch('global/getDistricts', competitionType)

          // 初始化完成，清除初始化标志
          this.isInitializing = false
          console.log('[DEBUG] Set isInitializing to false - initialization complete')
        })
        // if (!data.category_id) {
        //   setPageKey(0)
        //   this.step = 0
        //   return
        // }
        // 非管理员不能修改已完成注册的作品
        // if (data.register_status > 1 && !this.isAdmin && !this.productConfirm) this.readonly = true
      }).catch(res => {
        console.error(res)
      })
    },
    setSavedImagesNum(num) {
      this.savedImagesNum = num
    },
    setSavedMarketFileNum(num) {
      this.savedMarketFileNum = num
    },
    setSavedVideosNum(num) {
      this.savedVideosNum = num
    },
    goBack() {
      removePageKey('editProductId')
      removePageKey('productStep')
      removePageKey('readonly')
      if (this.editId) {
        this.$emit('setEditId', 0)
      } else {
        this.$router.back()
      }
    }
  }
}
</script>
<style scoped>
  footer {
    width: 100%;
    height: 70px;
    text-align: right;
    padding: 19px 24px;
    background: #ffffff;
    position: fixed;
    bottom: 0;
    right: 0;
  }

  footer button {
    margin-left: 16px;
  }
</style>
